// GERADO POR scripts/build-icons.js — não edite à mão.
// Fonte: handoff/assets/icons/emblem-hex.svg

import React from 'react';

/** Proporção nativa 24x24. */
export default function IconeEmblemHex({ size = 24, color = 'currentColor', strokeWidth, className, title, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth ?? 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 2l9 5v10l-9 5-9-5V7z"></path>
    </svg>
  );
}
